import React, { Fragment } from 'react'

import PropTypes from 'prop-types'
import GoogleMapReact from 'google-map-react'
import { withStyles } from '@material-ui/core/styles'

import TrapMapIcon from 'components/atoms/TrapMapIcon'
import MapControls from 'components/molecules/MapControls'
import HeatmapHelper from 'components/atoms/HeatmapHelper'
import InfoTrapLabel from 'components/atoms/InfoTrapLabel'
import MapPlaceholder from 'components/atoms/MapPlaceholder'

import { getGoogleApiKey } from 'utils/misc'

const defaultZoom = 15
const defaultCenter = {
  lat: -37.9259507,
  lng: 175.9140038,
}

const styles = theme => ({
  root: {
    minHeight: 400,
    position: 'relative',
    height: 'calc(100vh - 309px)',
  },
  controls: {
    top: 40,
    left: 40,
    zIndex: 10,
    position: 'absolute',
    animation: 'slideFromLeft .3s ease',
  },
  placeholder: {
    top: 0,
    left: 0,
    position: 'absolute',
  },
  icon: {
    width: 12,
    height: 12,
    borderRadius: 6,
    cursor: 'pointer',
    border: '2px solid white',
    backgroundColor: theme.palette.primary.main,
  },
})

const OverviewMap = ({
  data,
  loaded,
  classes,
  onChange,
  infoTipY,
  infoTipX,
  mapTypeId,
  onApiLoad,
  heatmapOpen,
  focusedTrap,
  infoTipTrap,
  focusedGroup,
  onTilesLoaded,
  toggleHeatmap,
  handleMapZoom,
  getMapOptions,
  handleMapReset,
  handleTrapClick,
  showArchivedTraps,
}) => {
  return (
    <div className={classes.root}>
      {data && data.groupLineDetails && data.groupLineDetails.length && (
        <Fragment>
          <GoogleMapReact
            onChange={onChange}
            mapTypeId={mapTypeId}
            options={getMapOptions}
            defaultZoom={defaultZoom}
            defaultCenter={defaultCenter}
            yesIWantToUseGoogleMapApiInternals
            bootstrapURLKeys={{
              key: getGoogleApiKey(),
              libraries: 'visualization',
            }}
            onGoogleApiLoaded={({ map, maps }) => onApiLoad(map, maps)}
            onTilesLoaded={onTilesLoaded}>
            {!heatmapOpen &&
              data.groupLineDetails.map((trap) => {
                const isGroupActive =
                    (!focusedGroup && !focusedTrap) ||
                    focusedGroup === trap.groupUuid
                const isTrapActive =
                    (!focusedTrap && !focusedGroup) ||
                    isGroupActive ||
                    focusedTrap === trap.trapUuid

                // if (trap.trapName == "Apps New  06" || trap.trapName == "Otira  03")
                // console.log(trap.trapName, trap.active, isTrapActive)
                return showArchivedTraps ?
                    <TrapMapIcon
                        trap={trap}
                        key={trap.historyUuid}
                        lat={trap.latitude}
                        lng={trap.longitude}
                        isActive={isTrapActive}
                        onClick={handleTrapClick}
                    />
                    : trap.active &&
                    <TrapMapIcon
                        trap={trap}
                        key={trap.historyUuid}
                        lat={trap.latitude}
                        lng={trap.longitude}
                        isActive={isTrapActive}
                        onClick={handleTrapClick}
                    />

              })}
          </GoogleMapReact>
          <MapControls
            handleZoom={handleMapZoom}
            heatmapActive={heatmapOpen}
            className={classes.controls}
            handleReset={handleMapReset}
            handleHeatmapToggle={toggleHeatmap}
          />
          <HeatmapHelper open={heatmapOpen} />
          {infoTipTrap && (
            <InfoTrapLabel x={infoTipX} y={infoTipY} data={infoTipTrap} />
          )}
        </Fragment>
      )}
      <MapPlaceholder
        isHidden={loaded}
        className={classes.placeholder}
        emptyStateTitle="Looks like there are no traps added yet"
        emptyStateDescription="Get started by sharing an invite code with Goodnature Chirp App users so they can share traps with you"
        showEmptyState={
          data && data.groupLineDetails && data.groupLineDetails.length === 0
        }
      />
    </div>
  ) 
}

OverviewMap.propTypes = {
  loaded: PropTypes.bool,
  data: PropTypes.object,
  zoom: PropTypes.number,
  heatmap: PropTypes.bool,
  onChange: PropTypes.func,
  center: PropTypes.object,
  onApiLoad: PropTypes.func,
  classes: PropTypes.object,
  infoTipY: PropTypes.number,
  infoTipX: PropTypes.number,
  showInfoTip: PropTypes.bool,
  heatmapOpen: PropTypes.bool,
  mapTypeId: PropTypes.string,
  infoTipTarget: PropTypes.any,
  activeTrap: PropTypes.string,
  onTilesLoaded: PropTypes.func,
  activeGroup: PropTypes.string,
  focusedTrap: PropTypes.string,
  toggleHeatmap: PropTypes.func,
  handleMapZoom: PropTypes.func,
  getMapOptions: PropTypes.func,
  infoTipTrap: PropTypes.object,
  focusedGroup: PropTypes.string,
  handleMapReset: PropTypes.func,
  handleTrapClick: PropTypes.func,
  showArchivedTraps: PropTypes.bool,
}

export default withStyles(styles)(OverviewMap)



// WEBPACK FOOTER //
// ./src/components/organisms/OverviewMap/OverviewMap.js